<template>
  <div id="welcome-broker.modal">
    <v-dialog :value="isModalActive" max-width="600" @input="inputModal">
      <v-card
        class="welcome-broker-modal-card pb-1"
        :color="$vuetify.theme.dark ? 'dark_backgroundDarkBlue' : undefined"
      >
        <v-card-title>
          {{ $t('views.brokers.welcomeBrokerModal.title') }}
        </v-card-title>

        <v-card-text class="py-0 pt-3">
          <p>
            {{ $t('views.brokers.welcomeBrokerModal.subtitle') }}
          </p>
          <v-row class="pr-2">
            <v-col cols="12" md="6" class="pb-1">
              <router-link to="/input?open=order&type=buy">
                <div class="option-card mt-3 pa-5 pt-6 pb-3">
                  <div class="d-flex">
                    <v-icon size="25" color="primary">mdi-plus</v-icon>
                    <div class="option-card-title ml-2">
                      {{ $t('views.brokers.welcomeBrokerModal.manually') }}
                    </div>
                  </div>
                  <div class="option-card-description mt-2">
                    {{ $t('views.brokers.welcomeBrokerModal.manuallyDescription') }}
                  </div>
                </div>
              </router-link>
            </v-col>
            <v-col cols="12" md="6" class="pb-1">
              <router-link :to="`/input?open=import&broker=${welcomeItem.code}`">
                <div class="option-card mt-3 pa-5 pt-6 pb-3">
                  <div class="d-flex">
                    <v-icon size="24" color="primary">mdi-file-upload-outline</v-icon>
                    <div class="option-card-title ml-2">
                      {{ $t('views.brokers.welcomeBrokerModal.import') }}
                    </div>
                  </div>
                  <div class="option-card-description mt-2">
                    {{ $t('views.brokers.welcomeBrokerModal.importDescription') }}
                  </div>
                </div>
              </router-link>
            </v-col>
          </v-row>

          <div class="footer mt-8 pt-6">
            {{ $t('views.welcomeModal.welcomeModalContinue.tutorials') }}
            <a href="https://www.filios.app/tutoriales" target="_blank">
              {{ $t('views.welcomeModal.welcomeModalContinue.showTutorials') }}
              <v-icon size="13" color="primary">mdi-open-in-new</v-icon>
            </a>
          </div>
          <div class="footer mt-0">
            {{ $t('views.welcomeModal.welcomeModalContinue.contact1') }}
            <a href="https://www.filios.app/contacta" target="_blank">
              {{ $t('views.welcomeModal.welcomeModalContinue.contact2') }}
            </a>
          </div>
        </v-card-text>

        <v-card-actions class="mt-0">
          <v-spacer />
          <v-btn class="mr-1" text :small="$vuetify.breakpoint.smAndDown" @click="closeModal">
            {{ $t('common.skip') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import modalMixin from '@/views/components/core/modalMixin.js'

export default {
  components: {},
  mixins: [modalMixin],
  props: {
    welcomeItem: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    // ...mapState(['user']),
  },
  methods: {
    resetForm() {},
  },
}
</script>

<style lang="scss">
.welcome-broker-modal-card {
  a {
    text-decoration: none;
  }
  .option-card {
    // min-height: 180px;
    height: 100%;
    border-radius: 20px;
    cursor: pointer;
    font-size: 14px;
    line-height: 1.7;
    color: #2597fe;

    background-color: white;
    border: 1px solid #eeeeee;
    &:hover {
      background-color: #f7f8fb;
      border: 1px solid #999;
    }

    .option-card-title {
      font-size: 16px;
      font-weight: 600;
    }
    .option-card-description {
      font-weight: 400;
      font-size: 13px;
      color: #636363;
      line-height: 1.5;
    }
  }

  .footer {
    font-size: 13px;
    line-height: 1.7;
  }
}
.theme--dark .welcome-broker-modal-card {
  .option-card {
    background-color: #323940;
    border: 1px solid #5b5b5b;
    &:hover {
      background-color: #3b444c;
      border: 1px solid #a5a5a5;
    }

    .option-card-description {
      color: white;
    }
  }
}
</style>
